import { sectionType } from '@/views/website/products/components/description/common/types';

export default {
  crawlType: 'marquee',
  matchTemplates: [
    {
      type: sectionType.sectionMarqueeBasicText,
      tags: [],
      priority: 1,
    },
  ],
};
